var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "short-list-item",
      style: { background: _vm.mBackground(8.1, "bottom") }
    },
    [
      _c(
        "div",
        { staticClass: "row row-center user-banner" },
        [
          _c("igc-user", { attrs: { item: _vm.item } }),
          _c("div", { staticClass: "col" }),
          _vm.item.is_my
            ? _c(
                "div",
                {
                  staticClass: "user_delete no-flex",
                  style: { color: _vm.mColor(3) },
                  on: {
                    click: function($event) {
                      _vm.isShortPopup = true
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "row row-center delete_inner" },
                    [
                      _c("sui-icon", {
                        staticClass: "ig--icon",
                        attrs: { fill: _vm.mColor(2.1), name: "trash" }
                      }),
                      _vm._v("\n                删除\n            ")
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "router-link",
        {
          directives: [
            {
              name: "dmp",
              rawName: "v-dmp",
              value: {
                action: "click,pop",
                targetid: _vm.item.iId,
                targettype: "moment",
                title: _vm.item.sTitle,
                from: "ingame"
              },
              expression:
                "{action:'click,pop', targetid: item.iId, targettype: 'moment', title: item.sTitle, from: 'ingame'}"
            }
          ],
          staticClass: "ig--content-text ig-style--ellipsis-2",
          style: { color: _vm.mColor(1) },
          attrs: { to: "/detail/short/" + _vm.item.guide_id, tag: "div" }
        },
        [_vm._v(_vm._s(_vm._f("igDecodeUnicode")(_vm.item.guide_content)))]
      ),
      _c(
        "div",
        { staticClass: "content-bottom row row-center" },
        [
          _c(
            "igc-like",
            {
              attrs: { item: _vm.item },
              on: {
                "update:item": function($event) {
                  _vm.item = $event
                }
              }
            },
            [
              _c("sui-icon", {
                staticClass: "ig--icon comment-icon",
                attrs: { name: "message-outline", fill: _vm.mColor(3) }
              }),
              _vm.item.igNum
                ? _c(
                    "div",
                    {
                      staticClass: "ig--text comment-num",
                      style: { color: _vm.mColor(3) }
                    },
                    [
                      _vm._v(
                        _vm._s((_vm.item.igNum && _vm.item.igNum.comment) || 0)
                      )
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "ig--text comment-num",
                      style: { color: _vm.mColor(3) }
                    },
                    [_vm._v("0")]
                  )
            ],
            1
          ),
          _c("div", { staticClass: "col" }),
          _c("div", { staticClass: "text-right" }, [
            _c(
              "div",
              { staticClass: "content-tag row" },
              [
                !_vm.notag
                  ? _c("igc-item-tag", { attrs: { item: _vm.item } })
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "igc-popup",
        {
          attrs: { config: _vm.shortPopup, show: _vm.isShortPopup },
          on: { cancel: _vm.cancelShort, confirm: _vm.deleteShort }
        },
        [
          _c("div", { staticClass: "pop-content" }, [
            _c(
              "div",
              {
                staticClass: "shortPopup text-center",
                style: { color: _vm.mColor(1) }
              },
              [_vm._v("确定删除此评论吗")]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }